import {
  GetLiderClubes,
  GetLiderReporte,
  State as ComisionMembresiaState
} from "../../../reducers/comisionMembresia";

export interface ReporteLiderStore extends GetLiderClubes, GetLiderReporte {}

export const reporteLiderStore: (state) => ReporteLiderStore = state => {
  const comisionMembresia: ComisionMembresiaState = state.comisionMembresia;

  return {
    liderClubes: comisionMembresia.liderClubes,
    gettingLiderClubes: comisionMembresia.gettingLiderClubes,
    gettingLiderClubesError: comisionMembresia.gettingLiderClubesError,

    liderReporte: comisionMembresia.liderReporte,
    gettingLiderReporte: comisionMembresia.gettingLiderReporte,
    gettingLiderReporteError: comisionMembresia.gettingLiderReporteError
  };
};
